<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_toc_2">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#a__Hlk164772692">Dedication</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_toc_4">Acknowledgments</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#auto_bookmark_toc_5">Chapter One</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#auto_bookmark_toc_6">Chapter Two</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007#auto_bookmark_toc_7">Chapter Three</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0008#auto_bookmark_toc_8">Chapter Four</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0009#auto_bookmark_toc_9">Chapter Five</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0010#auto_bookmark_toc_10">Chapter Six</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0011#auto_bookmark_toc_11">Chapter Seven</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0012#auto_bookmark_toc_12">Chapter Eight</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0013#auto_bookmark_toc_13">Chapter Nine</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0014#auto_bookmark_toc_14">Chapter Ten</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0015#auto_bookmark_toc_15">Chapter Eleven</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0016#auto_bookmark_toc_16">Chapter Twelve</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0017#auto_bookmark_toc_17">Chapter Thirteen</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0018#auto_bookmark_toc_18">Chapter Fourteen</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0019#auto_bookmark_toc_19">Chapter Fifteen</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0020#auto_bookmark_toc_20">Chapter Sixteen</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0021#auto_bookmark_toc_21">Chapter Seventeen</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0022#auto_bookmark_toc_22">Chapter Eighteen</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0023#auto_bookmark_toc_23">Chapter Nineteen</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0024#auto_bookmark_toc_24">Chapter Twenty</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0025#auto_bookmark_toc_25">Chapter Twenty-One</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0026#auto_bookmark_toc_26">Chapter Twenty-Two</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0027#auto_bookmark_toc_27">Chapter Twenty-Three</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0028#auto_bookmark_toc_28">Chapter Twenty-Four</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0029#auto_bookmark_toc_29">Chapter Twenty-Five</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0030#auto_bookmark_toc_30">Chapter Twenty-Six</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0031#auto_bookmark_toc_31">Chapter Twenty-Seven</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0032#auto_bookmark_toc_32">Chapter Twenty-Eight</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0033#auto_bookmark_toc_33">Chapter Twenty-Nine</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0034#auto_bookmark_toc_34">Chapter Thirty</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0035#a__Hlk167891378">Keep Reading</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0036#auto_bookmark_toc_36">About the Author</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0037#auto_bookmark_toc_37">By Eliana West</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0038#auto_bookmark_toc_38">More from Eliana West</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0039#auto_bookmark_toc_40">Copyright</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?31ddf359